import { Icon, IconProps } from "@chakra-ui/react";

export function BlingIcon(props: IconProps) {
  return (
    <Icon viewBox="0 0 24 24" fill="none" {...props}>
      <path d="M12 2L12 5" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M12 19L12 22" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M22 12L19 12" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M5 12L2 12" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M19.071 4.92946L16.9497 7.05078" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M7.05003 16.949L4.92871 19.0703" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M4.92897 4.92946L7.05029 7.05078" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M16.9495 16.949L19.0708 19.0703" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
    </Icon>
  );
}
